import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const PILL = "border-2 border-black px-3 py-1 text-[10px] uppercase tracking-widest transition-colors duration-100";
const RANGES = [[7, "7 days"], [30, "30 days"], [90, "90 days"]];

function Row({ name, r, testId, bold }) {
  return (
    <tr className={`border-t border-zinc-200 ${bold ? "font-bold bg-zinc-50" : ""}`} data-testid={testId}>
      <td className="px-3 py-2">{name}</td>
      <td className="px-3 py-2 text-right font-mono">{r.landing}</td>
      <td className="px-3 py-2 text-right font-mono">{r.thank_you}</td>
      <td className="px-3 py-2 text-right font-mono">{r.landing + r.thank_you}</td>
    </tr>
  );
}

function Range({ q, setQ }) {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  return (
    <div className="flex flex-wrap items-end gap-2" data-testid="call-taps-range">
      {RANGES.map(([d, l]) => (
        <button key={d} type="button" onClick={() => setQ({ days: d })} data-testid={`call-taps-days-${d}`}
                className={`${PILL} ${q.days === d ? "bg-black text-white" : "bg-white hover:bg-zinc-100"}`}>{l}</button>
      ))}
      <label className="text-[10px] uppercase tracking-widest">From
        <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="ml-1 border-2 border-black px-1 py-0.5" data-testid="call-taps-from" />
      </label>
      <label className="text-[10px] uppercase tracking-widest">To
        <input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="ml-1 border-2 border-black px-1 py-0.5" data-testid="call-taps-to" />
      </label>
      <button type="button" disabled={!from || !to} onClick={() => setQ({ from, to })} data-testid="call-taps-apply"
              className={`${PILL} bg-white hover:bg-zinc-100 disabled:opacity-40`}>Show</button>
    </div>
  );
}

/** How often visitors tap each buyer's call button, on landing pages vs thank-you pages. */
export default function AdminCallTaps() {
  const [q, setQ] = useState({ days: 30 });
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/call-taps", { params: q }).then((r) => setData(r.data))
      .catch((e) => toast.error(e?.response?.data?.detail || "Couldn't load call taps"));
  }, [q]);
  return (
    <div className="space-y-6" data-testid="call-taps-page">
      <div>
        <div className="label-mono">Report</div>
        <h1 className="font-chivo text-4xl font-black uppercase tracking-tighter sm:text-5xl">Call taps</h1>
        <p className="mt-2 max-w-3xl text-sm text-zinc-700">
          Taps on each buyer&apos;s call buttons. Landing pages count the top bar, sticky and hero call buttons; thank-you
          pages count the call buttons after a lead is sent. One tap per visitor every 30 minutes; previews and tests don&apos;t count.
        </p>
      </div>
      <Range q={q} setQ={setQ} />
      {!data ? <div className="label-mono">Loading…</div> : (
        <div className="overflow-x-auto border-2 border-black bg-white">
          <div className="border-b-2 border-black px-3 py-2 text-[10px] uppercase tracking-widest" data-testid="call-taps-period">{data.from} to {data.to}</div>
          <table className="w-full text-sm" data-testid="call-taps-table">
            <thead className="bg-zinc-100 text-left text-[10px] uppercase tracking-widest">
              <tr><th className="px-3 py-2">Buyer</th><th className="px-3 py-2 text-right">Landing pages</th><th className="px-3 py-2 text-right">Thank-you pages</th><th className="px-3 py-2 text-right">Total</th></tr>
            </thead>
            <tbody>
              {data.rows.length === 0 && <tr><td colSpan={4} className="label-mono px-3 py-6 text-center" data-testid="call-taps-empty">No call taps in this period</td></tr>}
              {data.rows.map((r) => <Row key={r.code} name={r.firm_name} r={r} testId={`call-taps-row-${r.code}`} />)}
              {(data.no_buyer.landing + data.no_buyer.thank_you) > 0 && <Row name="No buyer shown (your company page)" r={data.no_buyer} testId="call-taps-row-none" />}
              <Row name="Total" r={data.totals} testId="call-taps-row-total" bold />
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
